export default "__VITE_ASSET__92323cc6__"